import React from 'react';
import { useIntl } from 'react-intl';
import TarefasContainer from './tarefas.container';

function TarefasPage() {
    const intl = useIntl()
    return <TarefasContainer intl={intl} />;
}

export default TarefasPage;


// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.page.js